import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_entity_spending_limit_line_RowInterface, bl_fi_mst_entity_spending_limit_line_RowClass } from "../../../dbschema";

export class EntitySpendingLimitContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_spending_limit_line: bl_fi_mst_entity_spending_limit_line_RowInterface = new bl_fi_mst_entity_spending_limit_line_RowClass();
}
